/*
  Standalone entry point for the video-library carousel.

  Swiper (plus dom7 / ssr-window) was ~71kB of the global index.js bundle, but
  `.js-video-library-swiper` appears in exactly one view -
  Features/VideoDetailKenticoController/VideoDetail.cshtml - and nowhere in CMS
  content. Every other page downloaded and parsed it for nothing.

  bluetasks compiles each top-level file in frontend/js/ into its own bundle, so
  this becomes dist/js/videoSwiper.js, which VideoDetail.cshtml loads with defer.

  This deliberately does NOT `import Blue from "~/core"`. Blue's constructor
  calls Object.entries() over the utils and plugins barrels to attach every
  helper to each instance, so the whole barrel - date-fns, lodash-es, pickit,
  floating-ui, detect-browser - is unshakeable and gets pulled into any bundle
  that touches it. Importing it here cost ~110kB of duplication and made this
  bundle bigger than the saving. The init contract below is the small part of
  Blue that this component actually used, reproduced verbatim in behaviour:
  run setup once per matching element on DOMContentLoaded, and re-scan on DOM
  mutation while the Kentico Page Builder is editing the page.
*/
import shave from 'shave';
import Swiper, { Navigation, A11y, Keyboard } from 'swiper';

const NAME = 'Video Library Slideshow';
const SELECTOR = '.js-video-library-swiper';

function setup(registration) {
  Swiper.use([Navigation, A11y, Keyboard]);

  const truncate = registration.querySelectorAll('.text-truncate');
  const maxheight = 50;

  // [slidesPerView, spaceBetween]
  let sizesLg = [3.5, 30];
  if (registration.classList.contains('video-library-swiper--large')) {
    // variant for the fundamentals page
    sizesLg = [3, 15];
  }

  setTimeout(() => {
    new Swiper(registration, {
      direction: 'horizontal',
      breakpoints: {
        1: { slidesPerView: 1.5, spaceBetween: 30 },
        576: { slidesPerView: 2.5, spaceBetween: 30 },
        900: { slidesPerView: sizesLg[0], spaceBetween: sizesLg[1] },
      },
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        containerRoleDescriptionMessage: 'carousel',
        itemRoleDescriptionMessage: 'slide',
      },
      keyboard: { enabled: true, onlyInViewport: true },
    });

    truncate.forEach(e => shave(e, maxheight));
  }, 750);
}

// Same guard Blue's Initializer uses, so an element is only ever set up once
// even when the observer below re-scans.
function initAll() {
  document.querySelectorAll(SELECTOR).forEach(element => {
    if (!element._init) element._init = [];
    if (element._init.includes(NAME)) return;
    setup(element);
    element._init.push(NAME);
  });
}

document.addEventListener('DOMContentLoaded', initAll);

// In the Page Builder, widgets are added and re-rendered after load.
if (document.querySelector('html').classList.contains('kentico-page-builder')) {
  let timeoutId;
  new MutationObserver(() => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(initAll, 500);
  }).observe(document.querySelector('html'), { childList: true, subtree: true });
}
